import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import { RootState } from "../reducers";
import { useSelector } from "react-redux";

const PageSends = () => {
  const textPages = useSelector((state: RootState) => state.shop.textPages);
  return (
    <Container>
       {textPages?.textSends && parse(textPages.textSends)}
    </Container>
  );
}
export default PageSends;